// Blob URLs share the application's origin. Never turn untrusted MIME metadata
// into executable HTML/XML/SVG, including when seeding the upload cache.
const passiveTypes = new Set([
  'image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/avif', 'image/bmp',
  'image/x-icon', 'audio/mpeg', 'audio/mp4', 'audio/ogg', 'audio/wav', 'audio/webm',
  'audio/flac', 'video/mp4', 'video/webm', 'video/ogg', 'application/pdf',
  'text/plain', 'text/csv', 'text/markdown', 'application/json',
]);

export function safeAttachmentMime(mime) {
  const normalized = typeof mime === 'string' ? mime.split(';', 1)[0].trim().toLowerCase() : '';
  return passiveTypes.has(normalized) ? normalized : 'application/octet-stream';
}
